"use client"
import { Header } from "@/components/header"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
//import { MetricCard } from "@/components/metric-card"
//import { CalendarWidget } from "@/components/calendar-widget"
import { MapPin, Plus, IndianRupee, Calendar } from "lucide-react"
import { EventCard } from "@/app/events/event-card"
import { EventCountCard } from "@/app/events/event-count-card"
import Link from "next/link";
import { useContext } from "react";
import { EventsContext } from "./context/eventsContext";
import ReactGA from "react-ga4";
import { useEffect } from "react";

ReactGA.initialize("G-YB3K8KW036");

export default function Dashboard() {

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  const { events } = useContext(EventsContext);

  // return events older than today and also in "completed" state
  const completedEvents = events.filter((event) => {

    return event.status.toLowerCase().includes("completed") &&
      event.startDate && 
      new Date(event.startDate) < new Date()

  })

  // return events scheduled for today and 'in-progress' state
  const activeEvents = events.filter((event) => {

    return event.status.toLowerCase().includes("in-progress") &&
      event.startDate &&
      new Date(event.startDate) == new Date()

  })

  // return events scheduled after today and 'planned'
  const upcomingEvents = events.filter((event) => {

    return event.status.toLowerCase().includes("planned") ||
      event.startDate &&
      new Date(event.startDate) > new Date()

  })

  // use the budget amounts to calculate the below
  const pastEventsSpend = completedEvents.reduce((sum, event) => sum + event.budget, 0);

  const currentEventsSpend = activeEvents.reduce((sum, event) => sum + event.budget, 0);

  const upcomingEventsSpend = upcomingEvents.reduce((sum, event) => sum + event.budget, 0);

  return (
    <>
      <Header title="Dashboard" subtitle="Welcome back, here's what's happening with your events" />

      <div className="flex-1 overflow-auto p-6">

        <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">

          {/* Count of Events cards*/}
          <Card>

            <CardHeader>
              <CardTitle>Number of Events</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                <EventCountCard 
                title="Completed Events" 
                count={completedEvents.length} 
                colour="bg-blue-100" 
                bgcolour="text-blue-600"
                icon={Calendar}/>

                <EventCountCard 
                title="Active Events" 
                count={activeEvents.length} 
                colour="bg-red-100" 
                bgcolour="text-red-600"
                icon={Calendar}/>

                <EventCountCard 
                title="Upcoming Events" 
                count={upcomingEvents.length} 
                colour="bg-green-100" 
                bgcolour=" text-green-600"
                icon={Calendar}/>

              </div>
            </CardContent>
          </Card>

          {/* Spend on Events cards*/}
          <Card>
            <CardHeader>
              <CardTitle>Spend on Events</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                
                {/* Past Spend */}
                <EventCountCard 
                title="Past Spend (in INR)" 
                count={pastEventsSpend} 
                colour="bg-blue-100" 
                bgcolour="text-blue-600"
                icon={IndianRupee}/>

                {/* Current Spend */}
                <EventCountCard 
                title="Current Spend (in INR)" 
                count={currentEventsSpend} 
                colour="bg-red-100" 
                bgcolour="text-red-600"
                icon={IndianRupee}/>

                {/* Future Spend */}
                <EventCountCard 
                title="Future Spend (in INR)" 
                count={upcomingEventsSpend} 
                colour="bg-green-100" 
                bgcolour=" text-green-600"
                icon={IndianRupee}/>

              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <CardTitle>Completed Events</CardTitle>
                <CardTitle>Active Events</CardTitle>
                <CardTitle>Upcoming Events</CardTitle>
              </div>

            </CardHeader>
            
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                {/* Completed Event Details */}
                <div className="space-y-4">
                  {completedEvents.map((event) => (
                    <EventCard key={event.id} {...event}
                    />
                  ))}
                </div>
                {/* Active Event Details */}
                 <div className="space-y-4">
                  {activeEvents.map((event) => (
                    <EventCard key={event.id} {...event} />
                  ))}
                </div>

                {/* Upcoming Event Details */}
                <div className="space-y-4">
                  {upcomingEvents.map((event) => (
                    <EventCard key={event.id} {...event} />
                  ))}
                </div>

              </div>
            </CardContent>
          </Card>

        </div>

        {/* Quick actions */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Quick Actions</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">

              {/** Button to 'Create New Event' */}
              <Link href="/event-request">
                <Button variant="outline" className="w-full justify-start gap-3 h-auto p-4 bg-transparent">
                  <Plus className="h-5 w-5 text-primary" />
                  <div className="flex-1 text-left">
                    <div className="font-medium">Create New Event</div>
                    <div className="text-sm text-foreground" style={{ color: "grey" }}>Start planning your next event</div>
                  </div>
                </Button>
              </Link>

              {/** Button to 'Browse Venues' */}
              <Link href="/venues">
                <Button variant="outline" className="w-full justify-start gap-3 h-auto p-4 bg-transparent">
                  <MapPin className="h-5 w-5 text-primary" />
                  <div className="flex-1 text-left">
                    <div className="font-medium">Browse Venues</div>
                    <div className="text-sm text-foreground" style={{ color: "grey" }}>Find the perfect location</div>
                  </div>
                </Button>
              </Link>

            </CardContent>
          </Card>
        </div>
      </div>
    </>
  )
}
